import React, { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("sp_token"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogin = (token, userData = null) => {
    setToken(token);
    localStorage.setItem("sp_token", token);

    try {
      const decoded = jwtDecode(token);

      const mergedUser = {
        ...decoded,
        ...userData,
        userId: userData?.userId || decoded?.userId,
        userRole: userData?.role || decoded?.role,
        email: userData?.email || decoded?.email,
      };

      localStorage.setItem("sp_user", userData);
      localStorage.setItem("sp_role", mergedUser.userRole);
      localStorage.setItem("sp_userId", mergedUser.userId);

      setUser(mergedUser);
      return mergedUser;
    } catch (err) {
      console.error("Failed to decode token:", err);
      return null;
    }
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("sp_token");
    toast.info("Logged out successfully");
  };

  useEffect(() => {
    const existingToken = localStorage.getItem("sp_token");

    if (existingToken) {
      try {
        const decoded = jwtDecode(existingToken);

        if (decoded.exp * 1000 < Date.now()) {
          handleLogout();
          toast.info("Session expired. Please login again.");
        } else {
          setToken(existingToken);
          setUser(decoded);
        }
      } catch (err) {
        console.error("Invalid token:", err);
        handleLogout();
        toast.info("Session expired. Please login again.");
      }
    }

    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        loading,
        setUser,
        login: handleLogin,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
